/* BLANC SPACE: phone-colour preview pill + gallery swap (2026-09-28, moved
   onto the gallery 2026-09-29). See snippets/phone-colour-picker.liquid for
   the contract. Nothing here writes to the cart or the variant: it only
   chooses which rendered image the gallery shows for the selected phone /
   case type / bumper colour. */
(() => {
  const STORE_KEY = 'blancspace.phoneColour';
  const DESKTOP = '(min-width: 1000px)';
  const shell = document.querySelector('[data-bs-phone-colours]');
  if (!shell) return;

  const gallery = shell.closest('product-gallery');
  const wrapper = shell.parentElement;
  const button = shell.querySelector('[data-bs-colour-button]');
  const menu = shell.querySelector('[data-bs-colour-menu]');
  const list = shell.querySelector('[data-bs-phone-colours-list]');
  const swatch = shell.querySelector('[data-bs-colour-swatch]');
  const current = shell.querySelector('[data-bs-colour-current]');
  if (!gallery || !button || !menu || !list) return;

  const loadCatalog = (url) => fetch(url, { credentials: 'omit' }).then((r) => (r.ok ? r.json() : null)).catch(() => null);

  // the main-product picker is re-rendered on every variant change, so it is
  // looked up fresh; the variant itself is taken from the event when one fires
  const readVariant = () => {
    const picker = document.querySelector('.shopify-section--main-product variant-picker');
    try { return JSON.parse(picker.querySelector('script[data-variant]').textContent); } catch (e) { return null; }
  };

  const cfgFor = (kind, caseType, bumper) => {
    if (kind === 'air') return 'a';
    const pro = /pro/i.test(caseType);
    const black = /black/i.test(bumper || '');
    return (black ? 'ib' : 'i') + (pro ? 'm' : '');
  };

  // per-position image map for (variant, colour), falling back to the shot's default colour
  const resolve = (catalog, variant) => {
    const code = catalog.option_to_code[variant.option1];
    const kind = catalog.case_type_to_kind[variant.option2];
    const model = code && catalog.models[code];
    if (!model || !kind || !model[kind]) return null;
    const cfg = cfgFor(kind, variant.option2, variant.option3);
    const positions = model[kind];
    // the menu lists the finishes of SHOT 1 only: that is the shot every
    // render carries colours on (pre-17 models carry colours on shot 1 alone,
    // their shots 2-3 hold just a default finish, and unioning those added
    // stray "Silver"/"White" entries - 2026-10-06); other shots fall back to
    // their own default when they lack the chosen finish
    const first = positions['1'] && positions['1'][cfg];
    const colours = first ? Object.keys(first).filter((k) => k !== '_default') : [];
    const dflt = first ? first._default : null;
    return { code, kind, cfg, positions, colours, dflt };
  };

  const imageFor = (res, pos, colour) => {
    const c = res.positions[String(pos)] && res.positions[String(pos)][res.cfg];
    if (!c) return null;
    return c[colour] || c[c._default] || null;
  };

  // localStorage since 12 Oct 2026 so the choice carries from the collection page to here and across visits
  // (the collection pill writes the same key); the older sessionStorage value is read once as a fallback
  const readStored = () => { try { return localStorage.getItem(STORE_KEY) || sessionStorage.getItem(STORE_KEY) || ''; } catch (e) { return ''; } };
  const store = (colour) => { try { localStorage.setItem(STORE_KEY, colour); sessionStorage.setItem(STORE_KEY, colour); } catch (e) { /* private mode */ } };

  // Shopify holds its own copy of each group's DEFAULT-finish shots (the
  // rollout imports them), so the default finish is never swapped and a
  // Worker image that fails to load falls back to the Shopify copy: a Worker
  // or catalog outage leaves a normal Shopify gallery (Scott, 2026-10-06).
  const restoreImage = (img) => {
    if (!img || img.dataset.bsOrigSrc === undefined) return;
    img.setAttribute('src', img.dataset.bsOrigSrc);
    if (img.dataset.bsOrigSrcset) img.setAttribute('srcset', img.dataset.bsOrigSrcset); else img.removeAttribute('srcset');
    delete img.dataset.bsColourSrc;
  };
  // srcset via the Worker's on-request resize (2026-10-08): `?w=1200` returns a 1200px
  // AVIF/WebP/JPEG for phones, the bare URL is the 2000px master. A Worker without the
  // resize path ignores the query and serves the master, so this is safe either way.
  const srcsetFor = (base, file, master = 2000) => `${base}${file}?w=800 800w, ${base}${file}?w=1200 1200w, ${base}${file} ${master}w`;
  const swapImage = (img, url, srcset) => {
    if (!img || img.dataset.bsColourSrc === url) return;
    if (img.dataset.bsOrigSrc === undefined) {
      img.dataset.bsOrigSrc = img.getAttribute('src') || '';
      img.dataset.bsOrigSrcset = img.getAttribute('srcset') || '';
      img.addEventListener('error', () => { if (img.dataset.bsColourSrc) restoreImage(img); });
    }
    img.dataset.bsColourSrc = url;
    img.setAttribute('srcset', srcset || url);
    img.setAttribute('src', url);
  };

  const hiddenIndexes = () => {
    try { return JSON.parse(gallery.getAttribute('filtered-indexes') || '[]').map((n) => parseInt(n, 10) - 1); } catch (e) { return []; }
  };
  const visibleCells = (selector) => {
    const hidden = hiddenIndexes();
    return Array.from(gallery.querySelectorAll(selector)).filter((cell, index) => !hidden.includes(index) && !cell.hasAttribute('data-bs-deferred'));
  };

  const isDefaultFor = (res, pos, colour) => {
    const c = res.positions[String(pos)] && res.positions[String(pos)][res.cfg];
    return !c || !c[colour] || c._default === colour;
  };
  const applyToGallery = (res, colour, base) => {
    ['.product-gallery__media', '.product-gallery__thumbnail'].forEach((selector) => {
      visibleCells(selector).slice(0, 3).forEach((cell, shot) => {
        const img = cell.querySelector('img');
        if (!img) return;
        if (isDefaultFor(res, shot + 1, colour)) { restoreImage(img); return; }
        const file = imageFor(res, shot + 1, colour);
        if (file) swapImage(img, base + file, srcsetFor(base, file));
      });
    });
  };

  // Mobile: the pill floats bottom-left over the carousel (wrapper level), kept
  // narrow by CSS so it clears the case. Desktop grid: the wrapper's bottom is
  // under the LAST image, so the pill rides the first visible cell instead
  // (same reasoning as the product-note twin).
  const place = () => {
    const desktop = window.matchMedia(DESKTOP).matches;
    const target = desktop ? (visibleCells('.product-gallery__media')[0] || wrapper) : wrapper;
    if (shell.parentElement !== target) target.appendChild(shell);
  };

  const state = { colour: readStored(), catalog: null, base: '', res: null, open: false };

  const paintPill = (catalog, colour) => {
    const meta = catalog.colours[colour] || { label: colour, hex: '#ccc' };
    if (swatch) swatch.style.setProperty('--swatch-background', meta.hex);
    if (current) current.textContent = meta.label;
  };

  const renderMenu = (catalog, res, selected) => {
    const order = [res.dflt, ...res.colours.filter((c) => c !== res.dflt)].filter(Boolean);
    list.replaceChildren(...order.map((colour) => {
      const meta = catalog.colours[colour] || { label: colour, hex: '#ccc' };
      const label = document.createElement('label');
      label.className = 'bs-colour-menu__item';
      label.innerHTML =
        `<input class="sr-only" type="radio" name="bs-phone-colour" value="${colour}"${colour === selected ? ' checked' : ''}>` +
        `<span class="bs-colour-menu__swatch" style="--swatch-background:${meta.hex}" aria-hidden="true"></span>` +
        `<span class="bs-colour-menu__name">${meta.label}</span>` +
        '<svg class="bs-colour-menu__tick" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
      return label;
    }));
    shell.hidden = order.length < 2;
    paintPill(catalog, selected);
  };

  const positionMenu = () => {
    const rect = button.getBoundingClientRect();
    menu.style.left = `${Math.max(8, rect.left)}px`;
    menu.style.top = '';
    menu.style.bottom = `${Math.max(8, window.innerHeight - rect.top + 8)}px`;
  };
  const closeMenu = () => {
    if (!state.open) return;
    state.open = false;
    menu.hidden = true;
    button.setAttribute('aria-expanded', 'false');
  };
  const openMenu = () => {
    if (state.open) return;
    state.open = true;
    menu.hidden = false;
    positionMenu();
    button.setAttribute('aria-expanded', 'true');
    const checked = menu.querySelector('input:checked') || menu.querySelector('input');
    if (checked) checked.focus({ preventScroll: true });
  };
  button.addEventListener('click', () => (state.open ? closeMenu() : openMenu()));
  document.addEventListener('click', (event) => { if (state.open && !shell.contains(event.target)) closeMenu(); });
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && state.open) { closeMenu(); button.focus(); } });
  window.addEventListener('scroll', closeMenu, { capture: true, passive: true });
  window.addEventListener('resize', () => { closeMenu(); place(); });

  // Marketing tail: catalog.marketing[kind][cfg] = [{file, alt}] (one set per case type x bumper
  // colour, served from the Worker, never Shopify media). The gallery renders four hidden
  // [data-bs-tail] cells + thumbnails + mobile page dots after the Shopify media; fill the ones in
  // use, hide the rest. Dots carry no <img>: they are only shown/hidden in step with their cell.
  const applyTail = (res, catalog, base) => {
    const list = (res && catalog.marketing && catalog.marketing[res.kind] && catalog.marketing[res.kind][res.cfg]) || [];
    for (let n = 1; n <= 4; n += 1) {
      const entry = list[n - 1];
      gallery.querySelectorAll(`[data-bs-tail="${n}"]`).forEach((cell) => {
        if (!entry) { cell.hidden = true; return; }
        const img = cell.querySelector('img');
        if (img) {
          const url = base + entry.file;
          if (img.getAttribute('src') !== url) { img.setAttribute('src', url); img.setAttribute('srcset', srcsetFor(base, entry.file, 2048)); img.setAttribute('alt', entry.alt || ''); }
        }
        cell.hidden = false;
      });
    }
  };

  const refresh = (variant) => {
    if (!state.catalog) return;
    variant = variant || readVariant();
    const res = variant && resolve(state.catalog, variant);
    state.res = res;
    place();
    applyTail(res, state.catalog, state.base);
    if (!res) { shell.hidden = true; closeMenu(); window.bsPhoneColourShown = null; return; }
    if (!res.colours.includes(state.colour)) state.colour = res.dflt;
    renderMenu(state.catalog, res, state.colour);
    applyToGallery(res, state.colour, state.base);
    // page-scoped record of what the gallery shows, read by the add_to_cart capture in custom.js
    // (only for this variant, so an upsell added alongside never inherits it)
    window.bsPhoneColourShown = {
      variantId: variant && variant.id, colour: state.colour, dflt: res.dflt, offered: res.colours.length,
    };
  };

  menu.addEventListener('change', (event) => {
    if (!event.target || event.target.name !== 'bs-phone-colour') return;
    const previous = state.colour;
    state.colour = event.target.value;
    store(state.colour);
    if (state.res) {
      paintPill(state.catalog, state.colour);
      applyToGallery(state.res, state.colour, state.base);
    }
    closeMenu();
    button.focus({ preventScroll: true });
    const variant = readVariant();
    if (window.bsPhoneColourShown) window.bsPhoneColourShown.colour = state.colour;
    try { window.posthog?.register?.({ phone_colour_pref: state.colour }); } catch (e) { /* analytics is best effort */ }
    if (typeof window.bsTrack === 'function') window.bsTrack('phone_colour_selected', {
      colour: state.colour, from: previous, is_default: !!state.res && state.colour === state.res.dflt,
      phone_model: variant && variant.option1, case_type: variant && variant.option2,
      handle: (location.pathname.match(/\/products\/([^/?#]+)/) || [])[1] || null,
      surface: 'product',
    });
  });

  // the deferred-gallery hydrator (custom.js) fills stubs in the capture phase
  // first, so this capture listener runs after it and sees real <img>s
  document.addEventListener('product:rerender', () => requestAnimationFrame(() => refresh()), true);
  document.addEventListener('variant:change', (event) => {
    const variant = event.detail && event.detail.variant;
    requestAnimationFrame(() => refresh(variant));
  });

  loadCatalog(shell.dataset.catalog).then((catalog) => {
    if (!catalog) return;
    state.catalog = catalog;
    state.base = catalog.base;
    refresh();
  });
})();
